module.exports = __webpack_public_path__ + "img/sandsOfTime.c654342f.png";